var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3683 7H16.0289V5C16.0289 3.89543 15.1335 3 14.0289 3V3H10.0289V3C8.92435 3 8.02892 3.89543 8.02892 5V7H4.63135C3.53135 7 2.63135 7.9 2.63135 9V19C2.63135 20.1 3.53135 21 4.63135 21H19.3683C20.4683 21 21.3683 20.1 21.3683 19V9C21.3683 7.9 20.4683 7 19.3683 7ZM10.0289 5.2C10.0289 5.08954 10.1185 5 10.2289 5H13.8289C13.9394 5 14.0289 5.08954 14.0289 5.2V6.8C14.0289 6.91046 13.9394 7 13.8289 7H10.2289C10.1185 7 10.0289 6.91046 10.0289 6.8V5.2ZM19.3683 18C19.3683 18.5523 18.9206 19 18.3683 19H5.63135C5.07906 19 4.63135 18.5523 4.63135 18V10C4.63135 9.44772 5.07906 9 5.63135 9H18.3683C18.9206 9 19.3683 9.44772 19.3683 10V18Z",
    fill: "#6860EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.7C12 11.3134 11.6866 11 11.3 11H8.7C8.3134 11 8 11.3134 8 11.7V12.3C8 12.6866 8.3134 13 8.7 13H11.3C11.6866 13 12 12.6866 12 12.3V11.7Z",
    fill: "#6860EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.7C16 15.3134 15.6866 15 15.3 15H8.7C8.3134 15 8 15.3134 8 15.7V16.3C8 16.6866 8.3134 17 8.7 17H15.3C15.6866 17 16 16.6866 16 16.3V15.7Z",
    fill: "#6860EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobIcon);
export default __webpack_public_path__ + "static/media/job-icon.f49117d12b6efc1c726362603201023e.svg";
export { ForwardRef as ReactComponent };